import { useQuery } from "@tanstack/react-query";
import { cachedFetch, getCachedData } from "../../utils/apiCache";

export const useProfile = () => {
  const normalize = (arr) =>
    (Array.isArray(arr) ? arr : [])
      .map((item) => (typeof item === "string" ? item : item?.Name || item?.name || item?.title || ""))
      .filter(Boolean);

  const processRecord = (record) => {
    if (!record) return record;
    return {
      ...record,
      technologies: normalize(record.technologies),
      certifications: normalize(record.certifications),
      interests: normalize(record.interests),
      publications: normalize(record.publications),
    };
  };

  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const token = localStorage.getItem("token");
      const res = await cachedFetch("/api/profile/get", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to load profile");
      const json = await res.json();
      const record = processRecord(Array.isArray(json) ? json[0] : json);
      
      return {
        avatar: record?.avatar ? `/assets/avatars/${record.avatar}` : null,
        name: [record?.first_name, record?.last_name].filter(Boolean).join(" ") || "User",
        email: record?.email,
        record: record,
      };
    },
    staleTime: Infinity, 
    cacheTime: 30 * 60 * 1000, 
    initialData: () => {
      const cached = getCachedData("/api/profile/get");
      if (cached) {
        const record = processRecord(Array.isArray(cached) ? cached[0] : cached);
        return {
          avatar: record?.avatar ? `/assets/avatars/${record.avatar}` : null,
          name: [record?.first_name, record?.last_name].filter(Boolean).join(" ") || "User",
          email: record?.email,
          record: record,
        };
      }
      return undefined;
    },
  });
};
